import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { PRIMARY_OUTLET, Router } from '@angular/router';
import { ClientService } from './domain/services/client.service';
import { SvgService } from './shared/material/services';

declare const gtag: Function;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
    constructor(
        private readonly _svg: SvgService,
        private readonly _client: ClientService,
        private readonly _router: Router,
        private readonly _title: Title
    ) {
        // Parse the URL to get the client code. Note the URL is different for
        // different environments:
        // Production: https://studentportal.literacypro.com/wy/home
        // QA:         https://test.literacypro.com/agletqa/wy/home
        // Local:      https://localhost:4201/wy/home
        // For local testing of different paths, set <base href="/agletlocal/"/>
        // in index.html then run "ng serve --serve-path agletlocal".

        var pathURL = this._router.parseUrl(window.location.pathname);
        var segmentPath = pathURL.root.children[PRIMARY_OUTLET]?.segments;
        if (
            segmentPath?.length >= 2 &&
            segmentPath[0].path.startsWith('aglet')
        ) {
            runtimeConfig.clientCode = segmentPath[1].path;
        } else if (segmentPath?.length >= 1) {
            runtimeConfig.clientCode = segmentPath[0].path;
        } else {
            // Redirect to the Genius LACES web site if a client code isn't present in the URL.
            window.location.href =
                'https://geniuslearning.com/laces-solutions/';
            return;
        }

        this._svg.register(
            'lps-password',
            'assets/img/shared-icons/password.svg'
        );
        this._svg.register(
            'lps-personal-info',
            'assets/img/shared-icons/personal info.svg'
        );
        this._svg.register(
            'lps-disclosure',
            'assets/img/shared-icons/disclosure.svg'
        );
        this._svg.register(
            'lps-education',
            'assets/img/shared-icons/education.svg'
        );
        this._svg.register(
            'lps-empty-search',
            'assets/img/shared-icons/empty search.svg'
        );
        this._svg.register('lps-error', 'assets/img/shared-icons/error.svg');
        this._svg.register(
            'lps-no-results',
            'assets/img/shared-icons/no results.svg'
        );
        this._svg.register(
            'lps-notification',
            'assets/img/shared-icons/notification.svg'
        );
        this._svg.register(
            'lps-sign-up',
            'assets/img/shared-icons/sign up.svg'
        );
        this._svg.register(
            'lps-social-background',
            'assets/img/shared-icons/social-background.svg'
        );
    }

    ngOnInit(): void {
        this._client.latest.subscribe((client) => {
            if (client?.portalName) this._title.setTitle(client.portalName);
        });
        this._client.load();
    }
}
